import React from "react";
import {Container} from "../Home/styleHome";
import {Container1, Container1Texto, Container2, ContainerHeader, Triangulo} from "../Componentes/styleComponentes";
import {ComponenteFeature} from "../Componentes/indexComponentes";
import {
    Archive, Crosshair,
    FileText,
    Framer,
    Paperclip,

} from "react-feather";

import {ImagemDisputa} from "../Disputa/styleDisputa";
import img_proposta from '../imagens/proposta@2x.png'

export const Proposta = ({proposta}) => {
    return (
        <Container id={"proposta"}>
            <ContainerHeader>
                <Container1 background={"#3E6683"}>
                    <ImagemDisputa scroll={proposta}>
                        <img
                            src={img_proposta}
                            height={"auto"}
                            width={"99%"}
                            alt={"disputa"}
                        />
                    </ImagemDisputa>
                    <Container1Texto>
                        <div style={{display: "flex"}}>
                            <div style={{fontSize: "50px", marginRight: "20px"}}>
                                <Paperclip size={"60px"} color="#000000" />
                            </div>
                            <header>
                                <span style={{color: "#000000"}}> MÓDULO</span>
                                <h2>PROPOSTA</h2>
                            </header>
                        </div>
                        <div>
                            <p>
                                Importe sua planilha, selecione seus documentos de habilitação e anexos da proposta e <b>automatize</b> o envio pro portal do comprasnet. Gerencie as propostas enviadas alterando, incluindo ou excluindo a qualquer momento.
                            </p>
                            <p>Gerencie suas propostas de maneira organizada e simplificada. Utilize um ambiente totalmente intuitivo, desenvolvido com o objetivo de tornar fácil algo que antes era complicado, ajudando na produtividade da sua equipe</p>
                        </div>
                    </Container1Texto>
                </Container1>
                <Triangulo/>
                <Container2>
                    <ComponenteFeature
                        status={proposta}
                        titulo={"PREENCHIMENTO RÁPIDO"}
                        subTitulo={"Cadastre sua proposta sem dor de cabeça"}
                        icone={<FileText/>}
                        texto={
                            "Preencha os dados e valores repetitivos de maneira facilitada."
                        }
                    />
                    <ComponenteFeature
                        status={proposta}
                        titulo={"UPLOAD DE ANEXOS"}
                        subTitulo={"Envie facilmente seus documentos"}
                        icone={<Archive/>}
                        texto={
                            "Enviar seus documentos se tornou um procedimento simples e rápido."
                        }
                    />
                    <ComponenteFeature
                        status={proposta}
                        titulo={"PROCESSO OBJETIVO"}
                        subTitulo={"Ambiente intuitivo e simplificado"}
                        icone={<Crosshair/>}
                        texto={
                            "Desenvolvemos uma forma eficaz de cadastrar sua proposta em poucos passos."
                        }
                    />
                    <ComponenteFeature
                        status={proposta}
                        titulo={"CONTROLE FACILITADO"}
                        subTitulo={"Administre sua proposta"}
                        icone={<Framer/>}
                        texto={
                            "Cadastrar, editar e excluir uma proposta se tornou simples, fácil e rápido."
                        }
                    />

                </Container2>
            </ContainerHeader>
        </Container>
    );
};
